import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../App.css'; // Ensure global styles are available

const Impressum = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: '#fff'
        }}>
            <Header />
            <div className="page-section" style={{ flex: 1 }}>
                <div className="headline">
                    <h2 className="title">Impressum</h2>
                </div>
                
                <div style={{
                    maxWidth: '800px',
                    fontFamily: '"mundial-narrow-variable", sans-serif',
                    fontVariationSettings: "'wght' 100",
                    fontSize: '18px',
                    lineHeight: '1.6',
                    marginTop: '2rem'
                }}>
                    <p style={{marginBottom: '2rem'}}>
                        <strong>LITHO</strong><br/>
                        Rita Lehnert
                    </p>
                    
                    <p style={{marginBottom: '2rem'}}>
                        Malvenstr. 12<br/>
                        8057 Zürich<br/>
                        Schweiz
                    </p>
                    
                    <p style={{marginBottom: '4rem'}}>
                        E-Mail: <a href="mailto:kontakt@litho.ch" style={{color: 'inherit', textDecoration: 'none'}}>kontakt@litho.ch</a><br/>
                        Telefon: +41 76 205 32 64<br/>
                        <a href="https://www.litho.ch" style={{color: 'inherit', textDecoration: 'none'}}>www.litho.ch</a>
                    </p>
                    
                    <h3 style={{ 
                        fontSize: '24px', 
                        marginTop: '40px', 
                        marginBottom: '16px', 
                        fontVariationSettings: "'wght' 300",
                        fontWeight: 'normal' 
                    }}>Haftungsausschluss</h3>
                    <p style={{marginBottom: '2rem'}}>Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen. Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne besondere Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</p>
                    
                    <h3 style={{ 
                        fontSize: '24px', 
                        marginTop: '40px', 
                        marginBottom: '16px', 
                        fontVariationSettings: "'wght' 300",
                        fontWeight: 'normal' 
                    }}>Haftungsausschluss für Links</h3>
                    <p style={{marginBottom: '2rem'}}>Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Websites abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.</p>
                    
                    <h3 style={{ 
                        fontSize: '24px', 
                        marginTop: '40px', 
                        marginBottom: '16px', 
                        fontVariationSettings: "'wght' 300",
                        fontWeight: 'normal' 
                    }}>Urheberrechte</h3>
                    <p style={{marginBottom: '2rem'}}>Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website, gehören ausschliesslich der Firma LITHO oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung des Urheberrechtsträgers im Voraus einzuholen.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Impressum;